/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelGetProjectListRequest,
  ModelGetProjectListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PublicProjectList<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get public project list
   *
   * @tags project
   * @name PublicProjectListCreate
   * @summary get public project list
   * @request POST:/publicProjectList
   */
  publicProjectListCreate = (
    request: ModelGetProjectListRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelGetProjectListResponse, any>({
      path: `/publicProjectList`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
